import { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import DasboardView from "./components/dashboardView/dasboardView";
import { getDashboardData } from "./services/dashboardapi";
import "../../styles/typography.css";
import "../Dashboard/styles/dashboard.css";
import Button from "../../components/atoms/button/Button";
import { formatDate } from "../../utility/Formatdate";
import SecondTab from "../../components/organisms/secondTab";
import DateRangePicker from "../../components/atoms/daterangePicker/DateRangePicker";
// import { LabAdminTabConfig } from "../Lab Admin Tabs/LabAdmin.constants";

const Dashboard = ({ TabConfig }) => {
  const today = new Date();
  const oneMonthAgo = new Date();
  oneMonthAgo.setMonth(today.getMonth() - 1);

  const [fromDate, setFromDate] = useState(oneMonthAgo);
  const [toDate, setToDate] = useState(today);
  const [dashboardData, setDashboardData] = useState({});

  const fetchData = async (params = {}) => {
    try {
      const data = await getDashboardData(params);
      setDashboardData(data);
    } catch (error) {
      console.error("Dashboard fetch failed", error);
    }
  };

  useEffect(() => {
    fetchData({
      from: formatDate(fromDate),
      to: formatDate(toDate),
    });
    // eslint-disable-next-line
  }, []);

  const handleSearch = (e) => {
    e.preventDefault();
    fetchData({
      from: formatDate(fromDate),
      to: formatDate(toDate),
    });
  };

  return (
    <div>
      <SecondTab tabConfig={TabConfig} />
      {/* Header Controls Section */}
      <div className="dashboard-header">
        {/* Single Tab */}
        <Button
          variant="active"
          size="md"
          style={{ minWidth: 112, height: 44, padding: "9px 20px" }}
          title="Dashboard View"
        >
          Dashboard View
        </Button>

        {/* Spacer pushes form to right */}
        <div className="ms-auto d-flex align-items-center">
          <Form className="d-flex align-items-center" onSubmit={handleSearch}>
            <DateRangePicker
              fromDate={fromDate}
              toDate={toDate}
              onFromDateChange={(date) => setFromDate(date)}
              onToDateChange={(date) => setToDate(date)}
              fromLabel="From"
              toLabel="To"
              className="me-3"
            />
            {/* Search Button */}
            <Button
              variant="outlined"
              size="md"
              style={{ minWidth: 76, height: 44, padding: "9px 20px" }}
              type="submit"
              onClick={handleSearch}
              title="Search"
            >
              Search
            </Button>
          </Form>
        </div>
      </div>

      {/* Main Dashboard Content */}
      <div
        style={{
          flex: 1,
          backgroundColor: "#ffffff",
          minHeight: "calc(100vh - 140px)",
        }}
      >
        <DasboardView data={dashboardData} />
      </div>
    </div>
  );
};

export default Dashboard;
